/*eslint-disable*/
import React from "react";
import DeleteIcon from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
// react components for routing our app without refresh
import { Link } from "react-router-dom";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Tooltip from "@material-ui/core/Tooltip";

// @material-ui/icons
import { Apps, People } from "@material-ui/icons";

// core components
import CustomDropdown from "components/CustomDropdown/CustomDropdown.js";
import Button from "components/CustomButtons/Button.js";

import styles from "assets/jss/material-kit-react/components/headerLinksStyle.js";

const useStyles = makeStyles(styles);

export default function HeaderLinks(props) {
  const classes = useStyles();
  return (
    <List className={classes.list}>
      <ListItem className={classes.listItem}>
        <Button
          href="/"
          color="transparent"
          className={classes.navLink}
          style={{ margin:0, padding:0, paddingRight:'10px', paddingLeft: '10px' }}
        >
        गृहपृष्ठ
        </Button>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Button
          href="/intro"
          color="transparent"
          className={classes.navLink}
          style={{ margin:0, padding:0, paddingRight:'10px', paddingLeft: '10px' }}
        >
        जिल्ला समन्वय समिति भक्तपुर
        </Button>
      </ListItem>
      {/*<ListItem className={classes.listItem}>
        <Button
          href="/intro"
          color="transparent"
          className={classes.navLink}
          style={{ margin:0, padding:0, paddingRight:'10px', paddingLeft: '10px' }}
        >
          परिचय
        </Button>
      </ListItem>*/}
      <ListItem className={classes.listItem} style={{ margin:0, padding:0, paddingRight:'10px', paddingLeft: '10px' }}>
        <CustomDropdown
          buttonText="नगरपालिकाहरू"
          buttonProps={{
            className: classes.navLink,
            color: "transparent",
            style: { margin:0, padding:0 }
          }}
          dropdownList={[
            <a
              href="/intro/changunarayan"
              className={classes.dropdownLink}
              style={{ margin:0, padding:0 }}
            >
              चाँगुनारायण नगरपालिका
            </a>,
            <a
              href="/intro/bhaktapur"
              className={classes.dropdownLink}
              style={{ margin:0, padding:0 }}
            >
              भक्तपुर नगरपालिका
            </a>,
            <a
              href="/intro/madhyapur_thimi"
              className={classes.dropdownLink}
              style={{ margin:0, padding:0 }}
            >
              मध्यपुर थिमि नगरपालिका
            </a>,
            <a
              href="/intro/suryabinayak"
              className={classes.dropdownLink}
              style={{ margin:0, padding:0 }}
            >
              सूर्यविनायक नगरपालिका
            </a>
          ]}
        />
      </ListItem>
      {/*<ListItem className={classes.listItem}>
        <Button
          href="/municipality"
          color="transparent"
          className={classes.navLink}
        >
          नगरपालिकाहरू
        </Button>
      </ListItem>*/}
      <ListItem className={classes.listItem}>
        <Button
          href="/budget"
          color="transparent"
          className={classes.navLink}
          style={{ margin:0, padding:0, paddingRight:'10px', paddingLeft: '10px' }}
        >
          बजेट
        </Button>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Button
          href="/project"
          color="transparent"
          className={classes.navLink}
          style={{ margin:0, padding:0, paddingRight:'10px', paddingLeft: '10px' }}
        >
          योजनाहरू
        </Button>
      </ListItem>

      <ListItem className={classes.listItem}>
        <Button
          href="/laws"
          color="transparent"
          className={classes.navLink}
          style={{ margin:0, padding:0, paddingRight:'10px', paddingLeft: '10px' }}
        >
          ऐन कानुन
        </Button>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Button
          href="/docs"
          color="transparent"
          className={classes.navLink}
          style={{ margin:0, padding:0, paddingRight:'10px', paddingLeft: '10px' }}
        >
          कागजात संग्रह
        </Button>
      </ListItem>
      {/*<ListItem className={classes.listItem}>
        <Button
          href="/ngo"
          color="transparent"
          className={classes.navLink}
          style={{ margin:0, padding:0, paddingRight:'10px', paddingLeft: '10px' }}
        >
          गैरसरकारी संस्था
        </Button>
      </ListItem>*/}
    </List>
  );
}
